import { useCallback, useState } from "react";
import { useAppDispatch } from "../../../../../store";
import { createContract } from "../../../../../acions/accounts/contracts";
import { FormInstance } from "antd";
import { transformToFloat } from "../../../../../lib/transformToFloat";

export const useCreateAccount = (
  form: FormInstance,
  onSuccess: (value: any) => void,
) => {
  const dispatch = useAppDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const onSave = useCallback(async () => {
    try {
      setIsLoading(true);

      const values = await form.validateFields();

      const request = {
        ...values,
        beginningDate: values.beginningDate.startOf("D").format(),
      };

      if (values.number) {
        request.number = transformToFloat(values.number);
      }

      const res: any = await Promise.resolve(dispatch(createContract(request)));

      setIsLoading(false);

      onSuccess({ ...res, accountNumber: res.name });
    } catch {
      setIsLoading(false);
    }
  }, [dispatch, form, onSuccess]);

  return { isLoading, setIsLoading, onSave };
};
